import { createAsyncThunk } from "@reduxjs/toolkit";
import { get, post } from "../../../api/api";
import { setLoading } from "../../../app/loadingSlice";

//Call fetch indicators ministries mapping list api request
export const fetchIndicatorsMinistriesMappingList = createAsyncThunk("indicatorsMinistriesMapping/fetchList", async (_, { dispatch }) => {
    dispatch(setLoading(true));
    try {
        const response = await get("/ministries/indicators")
        return response;
    } catch (error) {
        console.log(error)
    }
    finally {
        dispatch(setLoading(false));
    }
});

//Call map indicator and ministries api request
export const mapIndicatorsMinistry = createAsyncThunk("indicatorsMinistriesMapping/updateMapping", async (mapIndicatorsAndMinistry: any, {dispatch}) => {
    dispatch(setLoading(true));
    try {
        const response = await post("/ministries/indicators/map", mapIndicatorsAndMinistry);
        return response.data;
    } catch (error) {
        console.log(error)
    }
    finally{
        dispatch(setLoading(false));
    }
});

export const deleteIndicatorsMinistry = createAsyncThunk(
    "ministries/indicators/delete",
    async (finalObject: object, { dispatch }) => {
        dispatch(setLoading(true));
        try {
            const response = await post(`/ministries/indicators/delete`, finalObject);
            return response.data;
        } catch (error) {
            console.log(error);
        } finally {
            dispatch(setLoading(false));
        }
        dispatch(setLoading(false));

    }
);
